import { ReactNode } from 'react';
import { BlogHeader } from './BlogHeader';
import { BlogFooter } from './BlogFooter';

export function BlogLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      {/* Subtle background accent */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
      >
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 h-[32rem] w-[64rem] rounded-full bg-primary/10 blur-3xl" />
      </div>
      <BlogHeader />
      <main className="flex-1 w-full">{children}</main>
      <BlogFooter />
    </div>
  );
}
